import classNames from "classnames/bind";
import { useState } from "react";
import ChangePassword from "./ChangePassword/ChangePassword";
import styles from "./InfoUser.module.css";
import ShowInfoUser from "./ShowInfoUser/showInfoUser";
import Version from "./Version";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles)

function InfoUser() {
    const [currentPage, setCurrentPage] = useState(0)
    const handleChangePage = (value) => {
        setCurrentPage(value)
    }
    const { t } = useTranslation()
    const tabBar = [
        {
            tabIndex: 0,
            tabName: t("infoUser.info"),
            component: <ShowInfoUser />,
        },
        {
            tabIndex: 1,
            tabName: t("infoUser.changePassword"),
            component: <ChangePassword />,
        },
        {
            tabIndex: 2,
            tabName: t("infoUser.version"),
            component: <Version />,
        },
    ]
    return (
        <>
            <div className={cx("header")}>
                <h1 className={cx("title")}>{t("infoUser.header")}</h1>
            </div>
            <div className={cx('container')}>
                <div className={cx('content')}>
                    <div className={cx('content-header')}>
                        <div className={cx("content-title")}>
                            {tabBar.map(item => (
                                <button
                                    onClick={(e) => handleChangePage(item.tabIndex)}
                                    className={cx("button", currentPage === item.tabIndex && "active")}
                                    key={item.tabIndex}
                                >
                                    {item.tabName}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className={cx('content-body')}>
                        {tabBar.map(item => {
                            if (item.tabIndex === currentPage) {
                                return (
                                    <div key={item.tabIndex}>
                                        {item.component}
                                    </div>
                                )
                            } else {
                                return (
                                    <span key={item.tabIndex}></span>
                                )
                            }
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}
export default InfoUser;